/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Orderday_Name1Inputs */

const en_resources_orderday_name1 = /** @type {(inputs: Resources_Orderday_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders of the day`)
};

const fr_resources_orderday_name1 = /** @type {(inputs: Resources_Orderday_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commandes du jour`)
};

const es_resources_orderday_name1 = /** @type {(inputs: Resources_Orderday_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos del día`)
};

const de_resources_orderday_name1 = /** @type {(inputs: Resources_Orderday_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellungen des Tages`)
};

const nl_resources_orderday_name1 = /** @type {(inputs: Resources_Orderday_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellingen van de dag`)
};

/**
* | output |
* | --- |
* | "Orders of the day" |
*
* @param {Resources_Orderday_Name1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_orderday_name1 = /** @type {((inputs?: Resources_Orderday_Name1Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Orderday_Name1Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_orderday_name1(inputs)
	if (locale === "fr") return fr_resources_orderday_name1(inputs)
	if (locale === "es") return es_resources_orderday_name1(inputs)
	if (locale === "de") return de_resources_orderday_name1(inputs)
	return nl_resources_orderday_name1(inputs)
});
export { resources_orderday_name1 as "resources.orderDay.name" }